<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
          Pattern
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Pattern</a>
          </li>
      </ul>
    </div>
    <b-row>
      <b-col>
        <b-card>
          <b-row>
            <b-col>
              <strong>Pattern</strong> <small>Sets the pattern to be added to the examination.</small>
              <span class="float-right">{{model.created_at | datetime}}</span>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2">
              <label class="col-form-label" for="ph_is_use">Usage Status</label><br/>
            </b-col>
            <b-col>
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" v-model="model.is_alive" :disabled="lock">
                <div class="checkbox-animate">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
          <b-col md="2">
              <label for="" class="col-form-label">
                Level
              </label>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <b-form-select id="ph_level" v-model="model.level" :disabled="lock">
                  <option value="H">Danger</option>
                  <option value="W">Warning</option>
                  <option value="N">caution</option>
                  <option value="S">Suspicion</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <label for="" class="col-form-label">
                Type
              </label>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <b-form-select id="ph_type" v-model="model.type" :disabled="lock">
                  <option value="U">URL</option>
                  <option value="S">String</option>
                  <option value="R">Regex</option>
                  <option value="M">MD5</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2">
              <label class="col-form-label" v-b-tooltip.hover title="Please enter the code to look up on the confirmation page.">Code</label>
            </b-col>
            <b-col md="10">
              <b-form-group>
                <b-form-input :state="model.type == 'R' ? regex_valid(model.code) : (model.code && model.code.length > 0) || false" md="5" type="text" id="ph_code" v-model="model.code" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <template v-if="lock">
            <b-button size="sm" variant="primary" @click="edit" class="btn-add"> Edit </b-button>
            <b-button size="sm" variant="danger" @click="confirm = true"> Remove </b-button>
          </template>
          <template v-else>
            <b-button class="btn-add" size="sm" variant="success" @click="save"> Save </b-button>
            <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> Cancel </b-button>
          </template>
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>

    <b-modal title="Pattern Remove" class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      This operation cannot be reversed.
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
